<template>
  <div class="editor">
    <transition-group v-if="!isLoading" name="editor-contents">
      <product-layer-list v-if="currentStep == 0" :layerList="layerList" @select="selectLayout" @updateLayerList="getLayouts"/>
      <konva-sector-editor v-if="currentStep == 1" @editSector="editSector" :productLayer="currentLayer" @savedLayout="getCurrentLayoutData"/>
      <konva-seat-editor v-if="currentStep == 2" :currentSector="currentSector" :currentLayer="currentLayer" />
      <v-card class="table-section" v-if="currentStep == 1 && currentLayerSectors && currentLayerSectors.length != 0">
        <v-table class="sector-table">
          <thead>
            <tr>
              <th class="text-left">
                {{ $t('sectorEditor.sectorTable.headers.id') }}
              </th>
              <th class="text-left">
                {{ $t('sectorEditor.sectorTable.headers.layout') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in currentLayerSectors"
              :key="item.name"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.LayoutSectorSector.layout_seat_id != null ? $t('sectorEditor.sectorTable.content.haveLayout') : $t('sectorEditor.sectorTable.content.dontHaveLayout') }}</td>
            </tr>
          </tbody>
        </v-table>
      </v-card>
    </transition-group>
    <div v-else class="loading-container">
      <v-progress-circular
        size="73.5"
        indeterminate
        class="loading-circle"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import KonvaSectorEditor from '@/components/global/konva/KonvaSectorEditor';
import KonvaSeatEditor from '@/components/global/konva/KonvaSeatEditor';
import ProductLayerList from '@/components/global/konva/ProductLayerList'

export default {
  name: 'KonvaEditor',
  components: {
    KonvaSectorEditor,
    KonvaSeatEditor,
    ProductLayerList,
  },
  data() {
    return {
      currentStep: 0,
      currentSector: undefined,
      layerList: [],
      currentLayer: undefined,
      isLoading: true,
      currentLayerSectors: undefined,
    }
  },
  mounted() {
    document.addEventListener('mousedown', (e) => {
      e.preventDefault();
    })
    this.getLayouts();
    if (this.currentLayer) {
      this.getCurrentLayoutData();
    }
  },
  methods: {
    ...mapActions({
      getLayoutsApi: 'productLayout/getLayouts',
      getLayoutDataApi: 'productLayout/getLayoutData'
    }),
    getCurrentLayoutData() {
      this.getLayoutDataApi(this.currentLayer.id)
        .then((res) => {
          this.currentLayerSectors = res.sectors
        })
        .catch((err) => {
          console.log(err);
        })
    },
    getLayouts() {
      this.getLayoutsApi()
        .then((res) => {
          this.layerList = res;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
        })
    },
    editSector(sector) {
      this.currentLayerSectors.map((currentSector) => {
        if (currentSector.id == sector.attrs.id) {
          this.currentSector = currentSector;
        }
      })
      this.currentStep = -1
      setTimeout(() => {
        this.currentStep = 2;
      }, 500);
    },
    selectLayout(index) {
      this.currentLayer = this.layerList[index];
      this.currentStep = 1;
    }
  },
  watch: {
    currentLayer() {
      if (this.currentLayer) {
        this.getLayoutDataApi(this.currentLayer.id)
          .then((res) => {
            this.currentLayerSectors = res.sectors
          })
          .catch((err) => {
            console.log(err);
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.editor {
  height: calc(100% - 60px) !important;
  overflow-x: hidden;
}
.editor-contents-enter-active,
.editor-contents-leave-active {
  transition: all 0.5s ease;
  overflow: hidden;
}
.editor-contents-enter-from,
.editor-contents-leave-to {
  position: absolute;
  overflow: hidden;
  opacity: 0;
  transform: translateX(120px);
}
.table-section {
  margin: 26px 0 16px;
}
.loading-container {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: space-around;
}
</style>